export {default} from './ConsumptionLineChartComponent';
